import React, {useState} from "react";
import FullCardAndFilterSection from "./FullCardAndFilterSection/FullCardAndFilterSection";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, publicNav } from "../../utils/navItems";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";

const Explore = () => {
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        navItems={publicNav}
        setAddress={setAddress}
        bold={true}
        buttons={
          <div className="button-container">
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>
      <div className=" md:mb-[60px] flex justify-center">
        <div className="mt-[59px] mb-[12px] text-center">
          <h2 className="text-res-xl mb-[12px] font-bold">Explore</h2>
          <p className="text-res-ls flex gap-[12px] text-[#8A8AA0] md:leading-[28px]">
            <span>Home</span>
            <span>/</span>
            <span>NFT Marketplace</span>
            <span>/</span>
            <span className="text-white">Explore</span>
          </p>
        </div>
      </div>

      <FullCardAndFilterSection></FullCardAndFilterSection>

      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Explore;
